import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { useRef, useState } from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Button from 'flow/components/ui-components/Button';
import Room from 'flow/components/ui-components/Room';
import SearchInput from 'flow/components/ui-components/SearchInput';
import { newestFirst } from 'flow/utils';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectPublicSessions } from 'flow/selectors/chat-selectors';

const ListRoomsModal = () => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const timeoutId = useRef<NodeJS.Timeout | number>(null);
    const [searchTerm, setSearchTerm] = useState('');

    const rooms = useAppSelector(selectPublicSessions);

    const handleInput = (text: string) => {
        clearTimeout(timeoutId.current as number);

        timeoutId.current = setTimeout(() => {
            setSearchTerm(text);
        }, 400);
    };

    return (
        <BaseModal
            className="w-[924px] bg-gray-100"
            open={true}
            header={i18next.t('Chat.Public.Title')}
            disableActions={true}
        >
            <div className="flex flex-col gap-y-2">
                <div className="me-2 flex items-center gap-x-3">
                    <SearchInput
                        iconKey="search"
                        className="flex-1"
                        placeholder={i18next.t('Chat.Public.Search')}
                        autoFocus={true}
                        onChange={(e) => handleInput(e.target?.value)}
                    />

                    <Button
                        color="primary"
                        className="h-10 px-5"
                        onClick={() => openModal('managePublicRoom')}
                    >
                        {i18next.t('Chat.Public.Create.Title')}
                    </Button>
                </div>

                <div className="grid h-[49rem] grid-cols-1 gap-3 py-3 sm:grid-cols-2 md:grid-cols-3">
                    {rooms
                        .sort((a, b) => newestFirst(a, b))
                        .filter(
                            (room) =>
                                room
                                    .get('name')
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase()) ||
                                (room.has('roomDescription') &&
                                    room
                                        .get('roomDescription')
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())),
                        )
                        .map((room) => (
                            <Room
                                key={room.get('key')}
                                room={room}
                                className="h-96"
                            />
                        ))}
                </div>
            </div>
        </BaseModal>
    );
};

export default ListRoomsModal;
